import { styled, css } from "styled-components";

export const PressContainerHeaderLabel = css`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pt-serif);
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.43rem;
  display: flex;
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  flex: 1 0 0;
`;

export const CommonStyle = css`
  display: flex;
  flex: 1 0 0;
  padding: var(--Spacing-8, 0.8rem) var(--Spacing-4, 0.4rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const NewInfoPressTableContainer = styled.div<{ isResizing: boolean }>`
  display: flex;
  position: relative;
  height: ${({ isResizing }) => (isResizing ? "100%" : "100%")};
  max-height: ${({ isResizing }) =>
    isResizing ? "fit-content" : "fit-content"};
  overflow-y: auto;
  padding: var(--Spacing-8, 0.8rem);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-8, 0.8rem);
  align-self: stretch;
  border-radius: var(--Border-Radius-2, 0.2rem);
  background: var(--Color-Common-Bg-Primary, #fff);
  margin-top: 0.8rem;
  width: 100%;
`;

export const NewInfoPressTableTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.2rem;
  flex-direction: row;
  height: 1.6rem;
`;

export const NewInfoPressTableTitle = styled.div`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.56rem;
  flex-wrap: nowrap;
  white-space: nowrap;
`;

export const NewInfoPressTableTitleDescriptionWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 1.6rem;
  height: 1.6rem;

  &:hover {
    & > .tooltip-description {
      display: block;
    }
  }
`;

export const TooltipDescription = styled.div`
  position: absolute;
  top: 100%;
  max-width: 80rem;
  width: fit-content;
  display: flex;
  padding: var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--Spacing-4, 0.4rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  display: none;
`;

export const NewInfoPressTableTitleDescription = styled.div`
  color: var(--Color-Common-Text-Primary, #2a2f37);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  white-space: pre;
`;

export const NewInfoPressTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
`;

export const NewInfoPressTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  border-right: none;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
  height: 3.4rem;
  color: var(--Color-Common-Text-Primary, #2a2f37);
`;

export const NewInfoPressTableHeadDiv = styled.div`
  ${PressContainerHeaderLabel}

  & > .checkbox-wrapper {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const NewInfoPressTablePressId = styled.div`
  display: flex;
  max-width: 14.4rem;
  align-items: flex-start;
  ${CommonStyle}
`;

export const NewInfoPressTableNewInfoDetails = styled.div`
  ${CommonStyle}
  width: 100%;
`;

export const NewInfoPressTableReviewRequired = styled.div`
  max-width: 12.8rem;
  ${CommonStyle}
`;
